import { ObjectType } from '@/shared/entities/types';

const removeEmptyParams = <T = ObjectType>(obj: object, referenceValues = [undefined, '', null]) =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    if (!referenceValues.includes(value)) {
      return {
        ...acc,
        [key]: value,
      };
    }

    return acc;
  }, {}) as T;

export default removeEmptyParams;
